module.exports = __webpack_public_path__ + "static/media/icon_notificacion.3bb6ecd9.svg";